import { getMsgFromCls } from './getMsgFromCls.js';

var getSuper = function getSuper(name, msgOrParams) {
  var p = typeof msgOrParams === 'string' ? {
    message: msgOrParams
  } : msgOrParams;
  var _ref = p !== null && p !== void 0 ? p : {},
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? getMsgFromCls(name) : _ref$message,
    url = _ref.url,
    cause = _ref.cause,
    errorId = _ref.errorId,
    code = _ref.code,
    method = _ref.method;
  return {
    message: message,
    url: url,
    cause: cause,
    errorId: errorId,
    code: code,
    method: method
  };
};

export { getSuper };
